
import { Component, Vue } from 'vue-property-decorator'
import { commonModule, companyModule, actionTypesModule, itemTypesModule, labelModule } from '@/store/modules/store-accessor'
import Dropdown from '../components/dropdown/Dropdown.vue'
import DropdownItem from '../components/dropdown/DropdownItem.vue'
import FilterDropdown from '../components/dropdown/filter/FilterDropdown.vue'
import { customSearch, getDurationText, periodOptionToLabel, timeChargedUnitOption } from "@/helpers/data";

@Component({
  components: { Dropdown, DropdownItem, FilterDropdown }
})
export default class Management extends Vue {
  typesTableheaders: any [] = [
    { text: this.$t("actionTypeText"), sortable: true, class: 'row-style', value: 'text' },
    { text: this.$t("color"), sortable: true, class: 'row-style', value: 'color' },
    { text: this.$t("cost"), sortable: true, class: 'row-style', value: 'cost' },
    { text: this.$t("duration"), sortable: true, class: 'row-style', value: 'duration' },
    { text: this.$t("period"), sortable: true, class: 'row-style', value: 'periodic_option' },
    { text: this.$t("active"), sortable: true, class: 'row-style', value: 'is_active' },
    { text: '', align: 'right', width: '0px', sortable: false, class: 'row-style', value: 'id' }
  ]

  itemsTableheaders: any [] = [
    { text: this.$t("itemTypeText"), sortable: true, class: 'row-style', value: 'text' },
    { text: this.$t("active"), sortable: true, class: 'row-style', value: 'is_active' },
    { text: '', align: 'right', sortable: false, class: 'row-style', value: 'id' }
  ]

  expenseLabelsTableheaders: any [] = [
    { text: this.$t('name'), sortable: true, class: 'row-style', value: 'name' },
    { text: this.$t('color'), sortable: true, class: 'row-style', value: 'color' },
    { text: this.$t('labelCountSum'), sortable: true, class: 'row-style', value: 'label_count' },
    { text: '', align: 'right', width: '0px', sortable: false, class: 'row-style', value: 'id' }
  ]

  model: any = {
    typesSearch: '',
    itemsSearch: '',
    expenseLablesSearch: '',
    replyEmail: this.replyEmail,
    selected: [] as string[]
  }

  isUpdatingReplyEmail = false;

  emailRule:any =[
    (val: any) => !!val || this.$i18n.t("replyAddressRequiredRule"),
    (val: any) => val?.length <= 70 || this.$i18n.t("replyAddressLengthRule"),
    (val: any) => {
      //eslint-disable-next-line
      const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if(val?.length > 0) return reg.test(val) || this.$i18n.t("replyAddressInvalidRule");
      else return true;
    },
  ];

  get isEmailPreferenceValid() {
    return this.emailRule.every((rule: (val: any) => any) => rule(this.model.replyEmail) === true);
  }

  get isReplyEmailChanged() {
    return (this.model.replyEmail || '') !== (this.replyEmail || '');
  }

  get canSaveReplyEmail() {
    return this.isEmailPreferenceValid && this.isReplyEmailChanged && !this.isUpdatingReplyEmail;
  }

  get personnelLength() {
    return companyModule.personnel.length
  }

  get actionsSearchLabel() {
    return this.$t("actionTypesSearch")
  }

  get itemsSearchLabel() {
    return this.$t("itemTypesSearch")
  }

  get expenseLabelsSearchLabel() {
    return this.$t('expenseLabelsSearch')
  }

  get actionTypes(){
    return actionTypesModule.actionTypes;
  }

  get itemTypes(){
    return itemTypesModule.itemTypes;
  }

  get isLoadingTableActionTypes() {
    return actionTypesModule.isLoadingTable;
  }

  get isLoadingTableItemTypes() {
    return itemTypesModule.isLoadingTable;
  }

  get expenseLabels() {
    return labelModule.expenseLabels;
  }

  get expenseLabelsLength() {
    return labelModule.expenseLabels.length;
  }

  get isLoadingExpenseLabelsTable() {
    return labelModule.isLoadingExpenseLabelsTable;
  }

  get companyInfo() {
    return companyModule.company;
  }

  get replyEmail() {
    return companyModule.company.reply_email
  }

  get CompanyPreferences() {
    return Object.entries(companyModule.company?.preferences).map(([key, value]) => ({key, value }));
  }

  get JobPreferences() {
    const generalOptions = [
      'job_description', 'job_export_cost', 'job_export_show_actual_duration', 'job_export_show_images',
      'job_export_show_expenses', 'end_appointment_show_duration', 'appointment_request_signature',
      'job_export_show_appointment_signature',
    ];
    const optionsArray = this.CompanyPreferences.filter(obj => generalOptions.includes(obj.key));
    return optionsArray;
  }

  get OfferPreferences() {
    return this.CompanyPreferences.filter(obj => obj.key === 'offer_export_show_images');
  }

  get TechnicianPreferences() {
    const generalOptions = ['technician_view_client_phone', 'technician_enable_all_financials', 'technician_view_job_costs', 'technician_edit_client_from_installation', 'technician_calendar_view_days'];

    const clientSettingsOrder = ['technician_view_client_phone', 'technician_edit_client_from_installation', 'technician_enable_all_financials', 'technician_view_job_costs'];

    const optionsArray = this.CompanyPreferences.filter(obj => generalOptions.includes(obj.key)).sort((a, b) => {
      const allFincIndex = clientSettingsOrder.indexOf(a.key);
      const jobCostsIndex = clientSettingsOrder.indexOf(b.key);

      if (allFincIndex !== -1 && jobCostsIndex !== -1) { return allFincIndex - jobCostsIndex; }
      else if (allFincIndex !== -1) { return -1; }
      else if (jobCostsIndex !== -1) { return 1; }
      else { return 0; }
    });

    return optionsArray;
  }

  get InstallationPreferences() {
    const generalOptions = ['installation_description', 'job_export_show_installation_description'];
    const optionsArray = this.CompanyPreferences.filter(obj => generalOptions.includes(obj.key));
    return optionsArray;
  }

  get ItemsPreferences() {
    const itemsOptions = ['installation_item_description'];
    const optionsArray = this.CompanyPreferences.filter(obj => itemsOptions.includes(obj.key));
    return optionsArray;
  }

  technicianCalendarViewDaysOptions = [
    { text: this.$t('allDays'), value: null },
    ...[...Array(31).keys()].map(i => ({ text: i + 1, value: i + 1 }))
  ];

  async updateTechnicianCalendarViewDays(preference: string) {
    const preferenceObj = this.CompanyPreferences.find(p => p.key === preference);
    const days = preferenceObj?.value;

    await companyModule.editCompany({ id: companyModule.company.id, [preference]: days.value });
    await companyModule.getCompanyInfo(true);
  }

  get EmailPreferences() {
    const emailOptions = ['send_email_task_appointment', 'send_client_appointment_email'];
    const emailArray = this.CompanyPreferences.filter(obj => emailOptions.includes(obj.key));
    return emailArray;
  }

  setToInActive(action: any) {
    commonModule.showModal({ name: 'toggle-active-action-type-modal', payload: { actionType: action } })
  }

  setToInActiveItemType(item: any) {
    commonModule.showModal({ name: 'toggle-active-item-type-modal', payload: { itemType: item } })
  }

  customSearchFilter(value: any, search: any, item: any) {
    return customSearch(value, search, item);
  }

  periodicLabel(option: string) {
     return periodOptionToLabel(option);
  }

  async mounted () {
    commonModule.initSnackbar({});
    await actionTypesModule.getAllActionTypes();
    await itemTypesModule.getItemTypes();
    await companyModule.getCompanyInfo();
    this.model.replyEmail = this.replyEmail || '';
    await labelModule.getExpenseLabels();
    actionTypesModule.setIsLoadingTable(false);
    itemTypesModule.setIsLoadingTable(false);
    labelModule.setIsLoadingExpenseLabelsTable(false);
  }

  // --- Action Types ---
  async addActionType() {
    commonModule.showModal({ name: 'add-action-type-modal' })
  }

  async editActionType(actionType: any) {
    await actionTypesModule.getActionTypeById(actionType.id);
    commonModule.showModal({ name: 'edit-action-type-modal', payload: { actionType: actionType } })
  }

  async deleteActionType(actionType: any) {
    if (!actionType.is_used) {
      commonModule.showModal({ name: 'delete-action-type-modal', payload: { actionType: actionType } })
    }
  }

  actionCostText(action: Record<string, any>) {
    if(action.is_time_charged) {
      return `/ ${timeChargedUnitOption(action.unit)?.text}`;
    }
  }

  actionDurationText(duration: number) {
    return duration ? getDurationText(duration) : '-';
  }
  // --- Action Types End ---

  // --- Item Types ---
    async addItemType() {
    commonModule.showModal({ name: 'add-item-type-modal' })
  }

  async editItemType(itemType: any) {
    await actionTypesModule.getActionTypeById(itemType.id);
    commonModule.showModal({ name: 'edit-item-type-modal', payload: { itemType: itemType } })
  }

  async deleteItemType(itemType: any) {
    if (!itemType.is_used) {
      commonModule.showModal({ name: 'delete-item-type-modal', payload: { itemType: itemType } })
    }
  }
  // --- Item Types End ---

  // --- Expense Labels Start ---
  async addExpenseLabel() {
    commonModule.showModal({ name: 'add-expense-label-modal' });
  }

  async editExpenseLabel(label: LabelDto) {
    commonModule.showModal({ name: 'edit-expense-label-modal', payload: {label: label} });
  }

  async deleteExpenseLabel(label: LabelDto) {
    commonModule.showModal({ name: 'delete-expense-label-modal', payload: {label: label} });
  }
  // --- Expense Labels End ---

  async toggleInstallationDescription(key: any) {
    commonModule.showModal({ name: 'toggle-company-preferences-modal', payload: { key: key } })
  }

  disableSwitch(item: Record<string, any>) {
    if (item.key === 'technician_edit_client_from_installation') {
      const disableAllClientSettings = this.TechnicianPreferences.find(f => f.key === 'technician_view_client_phone');
      return disableAllClientSettings ? disableAllClientSettings.value === false : false;
    }

    if (item.key === 'technician_view_job_costs') {
      const enableAllFincs = this.TechnicianPreferences.find(f => f.key === 'technician_enable_all_financials');
      return enableAllFincs ? enableAllFincs.value === false : false;
    }

    return false;
  }

  showBooleanOption(preference: unknown) {
    return typeof preference === 'boolean';
  }

  get premiumPreferences() {
    return ['appointment_request_signature','job_export_show_appointment_signature', 'offer_export_show_images'];
  }

  get inactivePremiumPreferences() {
    let preferences = [];

    if(!companyModule.company?.modules?.includes('DFB_ADVANCED_PLAN')) {
      preferences.push('appointment_request_signature', 'job_export_show_appointment_signature', 'offer_export_show_images');
    }

    return preferences;
  }

  async doEditReplyEmail() {
    try {
      this.isUpdatingReplyEmail = true;
      await companyModule.editCompany({id: companyModule.company.id, ['reply_email']: this.model.replyEmail});
      await companyModule.getCompanyInfo(true);
      this.model.replyEmail = this.replyEmail || ''; // Just in case another user updated the same value at the same time
    } catch(error) {
      return error;
    } finally {
      this.isUpdatingReplyEmail = false;
    }
  }

}
